import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent implements OnInit {
  
  errorMessage = 'Die angeforderte Seite wurde nicht gefunden.';
  errorCode = '404';
  
  constructor(private router: Router) { }

  ngOnInit(): void {
    console.log('🚨 ErrorPageComponent ngOnInit - Component loaded!');
    console.log('📍 Current URL:', window.location.href);
    console.log('📍 Current pathname:', window.location.pathname);
    
    // Customize the error message based on the current route
    const currentUrl = window.location.pathname;
    
    if (currentUrl.includes('404') || currentUrl.includes('error-404')) {
      this.errorCode = '404';
      this.errorMessage = 'Die angeforderte Seite wurde nicht gefunden.';
    } else if (currentUrl.includes('403')) {
      this.errorCode = '403';
      this.errorMessage = 'Sie haben keine Berechtigung, diese Seite zu besuchen.';
    } else if (currentUrl.includes('500')) {
      this.errorCode = '500';
      this.errorMessage = 'Ein Serverfehler ist aufgetreten.';
    } else {
      this.errorCode = '404';
      this.errorMessage = 'Die angeforderte Seite wurde nicht gefunden.';
    }
    
    console.log('🎯 Error code:', this.errorCode);
    console.log('🎯 Error message:', this.errorMessage);
  }

  goToDashboard(): void {
    // Try to navigate to dashboard, if that fails, go to login
    this.router.navigate(['/dashboard']).catch(() => {
      this.router.navigate(['/auth/login']);
    });
  }

  goBack(): void {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // If no history, go to dashboard or login
      this.goToDashboard();
    }
  }

  getErrorTitle(): string {
    if (this.errorCode === '404') {
      return 'Seite nicht gefunden';
    } else if (this.errorCode === '403') {
      return 'Zugriff verweigert';
    } else if (this.errorCode === '500') {
      return 'Serverfehler';
    } else {
      return 'Fehler';
    }
  }
}
